var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElButton',_vm._b({attrs:{"type":"primary","native-type":"button","icon":"el-icon-plus","loading":_vm.loading},nativeOn:{"click":function($event){$event.preventDefault();return _vm.createReleaseHandler.apply(null, arguments)}}},'ElButton',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.$t('APP.RELEASES.NEW'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }